import { ENVS, getConfigName } from '@cld/env-config';
import { getConfig } from './config';
import { AppId, CUSTOMER_ID_PREFIX_FOR_URL } from '@cld/application-wrapper-common';

// https://cloudinary.com or https://staging.cloudinary.com
export const HOST = getConfig('host');

export const CONFIG_ENV = getConfigName();

// MPE env relative path, absolute for localhosts
export const MPE_HOST = CONFIG_ENV === ENVS.DEVELOPMENT ? HOST : '';

// https://console.cloudinary.com/console
export const MPE_CONSOLE = `${MPE_HOST}/console`;

export const MPE_VIDEO = `${MPE_HOST}/video`;

export const MENU_ITEM_ICON_SIZE = 'md';

export { CUSTOMER_ID_PREFIX_FOR_URL };

export const DOCUMENTATION_PAGE_URL = 'https://cloudinary.com/documentation';

export const ROADMAP_PAGE_URL = 'https://cloudinary.com/roadmap';

export const BLOG_PAGE_URL = 'https://www.cloudinary.com/blog';

export const ALL_SYSTEMS_OPERATIONAL_PAGE_URL = 'https://status.cloudinary.com';

export const TRAINING_PAGE_URL = 'https://training.cloudinary.com/learn/dashboard';

export const SETTINGS_PAGE_URL = `${MPE_HOST}/settings`;

export const MARKETPLACE_PAGE_URL = `${MPE_HOST}/marketplace`;

export const ADDON_PAGE_URL = `${SETTINGS_PAGE_URL}{customerId}/addons`;

export const ADD_NEW_USER_PAGE_URL = `${SETTINGS_PAGE_URL}{customerId}/users/new?page=users`;

export const FEEDBACK_SURVEY = CONFIG_ENV === (ENVS as Record<string, string>).PRODUCTION ? 35525514 : 25705601;

export const DEMO_PAGE_URL = `${HOST}/users/set_customer_demo`;

export const ADMIN_CONSOLE_URL = `${HOST}/admin`;

export const PM_RELEASE_NOTES = 'https://cloudinary.com/documentation/programmable_media_release_notes';

export const DAM_RELEASE_NOTES = 'https://cloudinary.com/documentation/digital_asset_management_release_notes';

export const CLD_LOGO_IMG_NAME = 'cld_new_default_cloud_logo_regular_padding.svg';

export const CLD_LOGO_SRC = `https://res-s.cloudinary.com/cloudinary/image/upload/d_console:${CLD_LOGO_IMG_NAME}/w_32,h_32,c_fill,dpr_2.0`;

export const SIDE_MENU_SESSION_STORAGE_KEY = 'cld-side-menu-open';

export const MM_PATH = `${MPE_HOST}/media-management-api`;

export const ME_PATH = `${MPE_HOST}/media-editing-api`;

export const MO_PATH = `${MPE_HOST}/media-optimizer`;

export const PM_PATH = `${MPE_HOST}/pm/c-{customerId}/`;

// eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
export const MEDIA_FLOWS_PATH = `https://console${CONFIG_ENV === ENVS.PRODUCTION ? '' : '-staging'}.cloudinary.com/mediaflows/c-{customerId}`;

export const DIMENSIONS_PATH = `https://console${CONFIG_ENV === ENVS.PRODUCTION ? '' : '-staging'}.cloudinary.com/3d/c-{customerId}`;

export const FINAL_TOUCH_PATH = 'https://bit.ly/3JgEH9m';

export const PME_PATH = MPE_CONSOLE;

export const DAM_PATH = `${MPE_CONSOLE}/media_library`;

export const VIDEO_PATH = `${MPE_VIDEO}/c-{customerId}/`;

export const APPS_EXPLORER_PATH = `${MPE_HOST}/home{customerId}/product-explorer`;

export const PRODUCT_EXPLORER_PATH = `${MPE_CONSOLE}{customerId}/home/product-explorer`;

export const APP_ID_TO_MPE_URL = {
  [AppId.ProgrammableMediaEditor]: ME_PATH,
  [AppId.Video]: VIDEO_PATH,
  [AppId.MediaOptimizer]: MO_PATH,
  [AppId.DigitalAssetManagement]: DAM_PATH,
  [AppId.CloudinaryAssets]: DAM_PATH,
  [AppId.Nexus]: DAM_PATH,
  [AppId.ProductExplorer]: PRODUCT_EXPLORER_PATH,
};

export const CLOUDINARY_SUPPORT = 'https://support.cloudinary.com/hc/en-us';

export const COMMUNITY_PAGE_URL = 'https://community.cloudinary.com/';
